<template>
  <div class="container">
    <div class="top">
      <img :src="obj.img" alt="" />
      <div class="flex">
        <div>
          <p>{{ member.length }}</p>
          <span>人数</span>
        </div>
        <p>|</p>
        <div>
          <p>{{ obj.score }}</p>
          <span>积分</span>
        </div>
        <p>|</p>
        <div>
          <p>{{ obj.hours }}</p>
          <span>小时</span>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="desc">
        <span class="subtitle">中文名</span>
        <span>{{ obj.name }}</span>
      </div>
      <div class="desc">
        <span class="subtitle">英文名</span>
        <span>{{ obj.name_en }}</span>
      </div>
      <!-- <div class="desc">
        <span class="subtitle">组织类型</span>
        <span>{{obj.org_type}}</span>
      </div> -->
      <div class="desc">
        <span class="subtitle">邮箱</span>
        <span>{{ obj.email }}</span>
      </div>
      <div class="desc">
        <span class="subtitle">传真</span>
        <span>{{ obj.chuanzhen }}</span>
      </div>
      <div class="desc">
        <span class="subtitle">主管部门</span>
        <span>{{ obj.bumen }}</span>
      </div>
      <div class="desc">
        <span class="subtitle">挂靠阵地</span>
        <span>{{ obj.p_org_name }}</span>
      </div>
      <div class="desc">
        <span class="subtitle">成立日期</span>
        <span>{{ obj.create_date }}</span>
      </div>
      <div class="desc">
        <span class="subtitle">所属区域</span>
        <span
          >{{ this.area }}<span v-if="street">-{{ this.street }}</span
          ><span v-if="village">-{{ this.village }}</span></span
        >
      </div>
      <div class="desc">
        <span class="subtitle">组织简介</span>
        <span v-html="obj.intro"></span>
      </div>
    </div>
    <div class="main" v-show="obj.join_info.length > 0">
      <p class="title">联系人信息</p>
      <div class="desc">
        <span class="subtitle">联系人姓名</span>
        <span>{{ obj.contact_name }}</span>
      </div>
      <div class="desc">
        <span class="subtitle">联系人电话</span>
        <span>{{ obj.contact_mobile }}</span>
      </div>
    </div>
    <div class="main" v-show="obj.join_info.length > 0">
      <p class="title">负责人信息</p>
      <div class="desc">
        <span class="subtitle">负责人姓名</span>
        <span>{{ obj.fuze_name }}</span>
      </div>
      <div class="desc">
        <span class="subtitle">负责人电话</span>
        <span>{{ obj.fuze_mobile }}</span>
      </div>
    </div>
    <!-- <div class="main">
      <p class="title">团队介绍</p>
      <p class="subtitle" style="padding:0 10px;" v-html="obj.intro"></p>
    </div> -->
    <div class="main">
      <div class="flexdiv">
        <p class="title">团队成员</p>
        <span class="count margin-left">{{ member.length }}人</span>
      </div>
      <div class="desc" style="padding: 0 10px"></div>
      <div class="pics">
        <div
          v-for="item in member"
          :key="item.index"
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin: 0px 5px;
          "
          @click="tohomepage(item.id)"
        >
          <img v-lazy="item.img" alt="" />
          <p style="font-size: 12px">{{ item.name }}</p>
        </div>
      </div>
    </div>
    <div class="main" style="margin-bottom: 90px">
      <div class="flexdiv">
        <p class="title">志愿活动</p>
        <span class="count margin-left">{{ eventcount }}个</span>
      </div>
      <div class="desc" style="padding: 0 10px"></div>
      <div
        class="desc"
        v-for="item in event"
        :key="item.index"
        style="display: flex"
        @click="urlchange(item.id)"
      >
        <img
          :src="item.img"
          alt=""
          style="
            width: 20vw;
            height: 15vw;
            object-fit: cover;
            border-radius: 5px;
            margin-right: 5px;
            flex-shrink: 0;
          "
        />
        <div class="right">
          <p class="subtitle">{{ item.title }}</p>
          <p class="margin-bottom">
            活动时间：{{ timeTransevent(item.starttime) }} ~
            {{ timeTransevent(item.endtime) }}
          </p>
          <span class="margin-bottom locate"
            ><i class="el-icon-location-information"></i
            >{{ item.address }}</span
          >
        </div>
      </div>
    </div>
    <div
      class="main"
      style="position: fixed; width: 100%; bottom: 0; margin: 0"
    >
      <el-button type="warning" @click="apply" v-if="obj.join_info.length == 0"
        >申请加入</el-button
      >
      <el-button
        type="warning"
        @click="quitorg"
        v-if="obj.join_info.length != 0 && obj.join_info.status == 2"
        >申请退出</el-button
      >
      <el-button
        type="warning"
        @click="quit"
        v-if="obj.join_info.length != 0 && obj.join_info.status == 1"
        >取消申请</el-button
      >
    </div>
  </div>
</template>
<script>
import { Dialog } from "vant";
export default {
  name: "orginazationdetail",
  data() {
    return {
      count: 27,
      jifen: 6933,
      hours: 6933,
      obj: {},
      member: [],
      event: [],
      eventcount: "",
      area: "",
      street: "",
      village: "",
      eventimg: [],
    };
  },
  created() {
    this.$axios({
      method: "post",
      url: "/api/org/zy_detail",
      data: this.qs.stringify({
        id: this.$route.query.id,
        token: sessionStorage.getItem("wmtoken"),
      }),
    }).then((res) => {
      console.log(res.data);
      if (res.data.code == 0) {
        this.obj = res.data.data;
        for (let i in res.data.data.member_list) {
          if (res.data.data.member_list[i].img == "") {
            res.data.data.member_list[i].img = "static/img/icon3.png";
          }
        }
        this.member = res.data.data.member_list;
        this.event = res.data.data.task_list;
        this.eventcount = res.data.data.task_list.length;
        this.eventimg = this.event.img.split(",");
        switch (res.data.data.org_type) {
          case 1:
            this.obj.org_type = "志愿组织";
            break;
          case 2:
            this.obj.org_type = "实践阵地";
            break;
          default:
            break;
        }
        let area = res.data.data.area;
        let street = res.data.data.street;
        let village = res.data.data.village;
        console.log(area.slice(0, 4));
        this.$axios({
          url: "/api/common/area",
          method: "post",
          data: this.qs.stringify({
            code: area.slice(0, 4),
            token: sessionStorage.getItem("wmtoken"),
          }),
        }).then((res) => {
          console.log(res.data);
          for (let i in res.data.data) {
            if (res.data.data[i].code == area) {
              this.area = res.data.data[i].name;
            }
          }
        });
        if (street != "") {
          this.$axios({
            url: "/api/common/area",
            method: "post",
            data: this.qs.stringify({
              code: street.slice(0, 6),
              token: sessionStorage.getItem("wmtoken"),
            }),
          }).then((res) => {
            console.log(res.data);
            for (let i in res.data.data) {
              if (res.data.data[i].code == street) {
                this.street = res.data.data[i].name;
              }
            }
          });
        }
        if (village != "") {
          this.$axios({
            url: "/api/common/area",
            method: "post",
            data: this.qs.stringify({
              code: village.slice(0, 9),
              token: sessionStorage.getItem("wmtoken"),
            }),
          }).then((res) => {
            console.log(res.data);
            for (let i in res.data.data) {
              if (res.data.data[i].code == village) {
                this.village = res.data.data[i].name;
              }
            }
          });
        }
      } else {
        this.$toast(res.data.msg);
      }
    });
  },
  methods: {
    urlchange(id) {
      this.$router.push({
        name: "detail",
        query: {
          id: id,
        },
      });
    },
    tohomepage(id) {
      this.$router.push({
        name: "homepage",
        query: {
          id: id,
        },
      });
    },
    apply() {
      this.$axios({
        method: "post",
        url: "/api/org/join",
        data: this.qs.stringify({
          token: sessionStorage.getItem("wmtoken"),
          id: this.$route.query.id,
        }),
      }).then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          this.$toast("已递交申请");
          this.$router.push("/orginazation");
        } else {
          this.$toast(res.data.msg);
        }
      });
    },
    quitorg() {
      Dialog.confirm({
        title: "提示",
        message: "确认退出该组织？",
      })
        .then(() => {
          // on confirm
          this.quit();
        })
        .catch(() => {
          // on cancel
        });
    },
    quit() {
      this.$axios({
        method: "post",
        url: "/api/org/leave",
        data: this.qs.stringify({
          token: sessionStorage.getItem("wmtoken"),
          id: this.$route.query.id,
        }),
      }).then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          this.$toast("您已成功退出该志愿组织");
          this.$router.push("/orginazation");
        } else {
          this.$toast(res.data.msg);
        }
      });
    },
  },
};
</script>
<style scoped>
.container {
  background: #f2f2f2;
}
.top {
  padding-bottom: 10px;
  background-image: linear-gradient(to bottom, #c93a39, #a02a24);
}
.top img {
  display: block;
  width: 100%;
  margin: 0 auto;
}
.flex {
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: white;
  margin-top: 20px;
}
.flex div {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.flex div p {
  font-size: 20px;
  font-weight: bold;
}
.flex div span {
  font-size: 14px;
}
.main {
  background: white;
  padding: 10px;
  font-size: 14px;
  margin-bottom: 10px;
}
.desc {
  padding: 10px;
  border-bottom: 1px solid #f2f2f2;
}
.subtitle {
  margin-right: 10px;
}
.title {
  font-weight: bold;
  font-size: 18px;
  padding-left: 10px;
  margin-bottom: 10px;
}
.flexdiv {
  display: flex;
  align-items: baseline;
}
.margin-left {
  margin-left: 10px;
}
.margin-bottom {
  margin-bottom: 10px;
}
.pics {
  padding: 10px 0;
  padding-left: 10px;
  overflow-x: scroll;
  white-space: nowrap;
  display: flex;
}
.pics img {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 50%;
}
.event {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: grey;
  font-size: 12px;
}
.label {
  padding: 5px 10px;
  border: 1px solid grey;
}
.locate {
  color: cornflowerblue;
}
.el-button {
  width: 80%;
  display: block;
  margin: 10px auto;
  background: #cab586;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/orginazationdetail.vue